import { Box, Modal, Button } from "@mui/material";

const ViewImageModal = ({ url, open, onClose }) => {
  const downloadImage = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      // Defaulting to .jpg if extension is unknown for simplicity, though the blob handles raw bytes perfectly
      a.download = url.split('/').pop() || 'document.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Modal fetch failed due to CORS block:", err);
      window.open(url, "_blank");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="image-modal"
      aria-describedby="modal-showing-full-image"
      sx={{
        zIndex: 9000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "697px",
          height: "568px",
          bgcolor: "#FFFFFF",
          borderRadius: "16px",
          boxShadow: 24,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        {/* Top Image Section */}
        <Box
          sx={{
            width: "100%",
            height: "504px",
            background: "#EBEDEE",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={url}
            alt="Full size preview"
            style={{
              maxWidth: "553px",
              maxHeight: "358px",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Bottom Actions Section */}
        <Box
          sx={{
            width: "100%",
            flexGrow: 1, // Expands to fill the remaining 64px bottom bar perfectly
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            onClick={onClose}
            disableElevation
            sx={{
              width: "112px",
              height: "36px",
              background: "#E9EAEC",
              borderRadius: "6px",
              color: "#000000",
              fontFamily: "Lato, Proxima Nova, sans-serif",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              textTransform: "none",
              padding: "9px 27px",
              "&:hover": { background: "#D1D3D6" }
            }}
          >
            Close
          </Button>

          <Button
            onClick={downloadImage}
            disableElevation
            sx={{
              width: "112px",
              height: "36px",
              background: "#000000",
              borderRadius: "6px",
              color: "#FFFFFF",
              fontFamily: "Lato, Proxima Nova, sans-serif",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              textTransform: "none",
              padding: "9px 24px",
              "&:hover": { background: "#333333" }
            }}
          >
            Download
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewImageModal;
